/**
 * Created by Abner Sui on 09/26/2019
 * -------------------------------------
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlideSheetComponent } from './slide-sheet.component';
import { TaskDetailModule } from '../work-flow/task-detail/task-detail.module';
import { TaskDetailComponent } from '../work-flow/task-detail/task-detail.component';
import { QuickTaskModule } from '../work-flow/quick-task/quick-task/quick-task.module';
import { QuickTaskComponent } from '../work-flow/quick-task/quick-task/quick-task.component';
import { TaskListModule } from '../work-flow/quick-task/task-list/task-list.module';
import { TaskListComponent } from '../work-flow/quick-task/task-list/task-list.component';
import { EntityPanelComponent } from '../entity-panel/entity-panel.component';
import { ContactPanelComponent } from '../contact-panel/contact-panel.component';
import { EntityPanelModule } from '../entity-panel/entity-panel.module';
import { ContactPanelModule } from '../contact-panel/contact-panel.module';
import { ExchangePanelComponent } from '../exchange/exchange-panel/exchange-panel.component';
import { TaskDefinitionModule } from '../work-flow/task-definition/task-definition.module';
import { TemplateConfigurationModule } from '../template-configuration/template-configuration.module';
import { WorkflowTriggerSettingsComponent } from '../work-flow/workflow-trigger-settings/workflow-trigger-settings.component';
import { TaskSettingWrapperComponent } from '../work-flow/task-definition-settings/task-setting-wrapper.component';
import { TaskSettingWrapperModule } from '../work-flow/task-definition-settings/task-setting-wrapper.module';
import { WorkflowTriggerSettingsModule } from '../work-flow/workflow-trigger-settings/workflow-trigger-settings.module';
import { ClickOutsideDirective } from '../../widgets/click-outside/click-outside.directive';
import { ExchangeSyncContactComponent } from '../exchange/exchange-sync-contact/exchange-sync-contact.component';

@NgModule({
    imports: [
        CommonModule,
        TaskDetailModule,
        QuickTaskModule,
        TaskListModule,
        EntityPanelModule,
        ContactPanelModule,
        TaskDefinitionModule,
        TemplateConfigurationModule,
        TaskSettingWrapperModule,
        WorkflowTriggerSettingsModule,
    ],
    declarations: [
        SlideSheetComponent,
        ClickOutsideDirective
    ],
    exports: [
        SlideSheetComponent,
    ],
    providers: []
})
export class SlideSheetModule { }
